import {
  INVALIDATE_ALL,
  SET_COMPONENT_INVALID,
  SET_COMPONENT_VALID,
} from 'reduxes/slices/invalid/actions'

const ROOT_STORE_INVALID_KEYS = ['actives']

const SUB_STORE_INVALID_KEYS = [
  'direct_chats_list',
  'timelines',
  'topics_list',
  'file_list',
]

export function invalidRootStore(
  state = { ...setAllKeysToRootStore(0), cablecar: 0 },
  action,
) {
  return handleInvalid(state, action, setAllKeysToRootStore)
}

export function invalidSubStore(state = setAllKeysToSubStore(0), action) {
  return handleInvalid(state, action, setAllKeysToSubStore)
}

const handleInvalid = (state, action, setAllKeysTo) => {
  const keys = Array.isArray(action.keys) ? action.keys : [action.keys]
  switch (action.type) {
    case SET_COMPONENT_VALID:
      return {
        ...state,
        ...setKeysTo(keys, 0),
      }
    case SET_COMPONENT_INVALID:
      return {
        ...state,
        ...setKeysTo(keys, 1),
      }
    case INVALIDATE_ALL:
      return {
        ...state,
        ...setAllKeysTo(1),
      }
    default:
      return state
  }
}

const setKeysTo = (keys, value) => {
  return keys.reduce((acc, key) => {
    acc[key] = value
    return acc
  }, {})
}

const setAllKeysToRootStore = (value) => {
  return setKeysTo(ROOT_STORE_INVALID_KEYS, value)
}

const setAllKeysToSubStore = (value) => {
  return setKeysTo(SUB_STORE_INVALID_KEYS, value)
}
